import React from 'react';
import PropTypes from 'prop-types';

import Tag from 'components/tags/tag';

export default function TagChip({ removable, tag, onRemove }) {
  return (
    <Tag removable={removable} onRemove={onRemove}>
      {tag}
    </Tag>
  );
}

TagChip.propTypes = {
  removable: PropTypes.bool,
  tag: PropTypes.string.isRequired,
  onRemove: PropTypes.func
};
